import { Link } from "react-router-dom";
import { PUBLIC_ROUTES } from "../../routes";
import MarketingShell from "./MarketingShell";

const STEPS = [
  {
    kicker: "01",
    title: "Walk the cell",
    body: "Capture a short walkthrough video or a photo set of the workcell. No CAD, no markers, no fixtures.",
  },
  {
    kicker: "02",
    title: "Generate the twin",
    body: "World Labs Marble turns the footage into a 3D scene. We post-process it into collision meshes with semantic tags — floor, table, obstacle — so a robot can actually move through it.",
  },
  {
    kicker: "03",
    title: "Randomise reality",
    body: "Produce variations of the same scene — different lighting, moved obstacles — so the policy you train survives the sim-to-real gap.",
  },
] as const;

export default function ProductScanToSim() {
  return (
    <MarketingShell>
      <section className="sg-hero">
        <div className="sg-hero-copy">
          <p className="sg-eyebrow">Pillar A · Scan-to-Sim</p>
          <h1>Turn a phone walkthrough into a physics-ready world twin.</h1>
          <p className="sg-hero-text">
            Manifold Kinetics pairs the RoboTwins world-twin pipeline
            with World Labs Marble to generate inspectable 3D scenes you
            can simulate, randomise, and ship into training in minutes —
            no CAD, no survey crew, no weeks of modelling.
          </p>
          <div className="sg-hero-actions">
            <Link to={PUBLIC_ROUTES.signup} className="sg-btn sg-btn-primary">
              Request a pilot
            </Link>
            <Link to={PUBLIC_ROUTES.productIntelligenceCore} className="sg-btn sg-btn-secondary">
              See Intelligence Core
            </Link>
          </div>
        </div>
      </section>

      <section className="sg-workflow">
        <div className="sg-section-heading">
          <p className="sg-section-kicker">How it works</p>
          <h2>From pixels to physics in three steps.</h2>
        </div>
        <div className="sg-workflow-grid">
          {STEPS.map((step) => (
            <article className="sg-step-card" key={step.title}>
              <span>{step.kicker}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </article>
          ))}
        </div>
      </section>
    </MarketingShell>
  );
}
